module.exports = "mutation handoffUser($user: HandoffUserInput!) {\n  handoffUser(input: $user) {\n    user {\n      id\n      email\n    }\n  }\n}\n"